import { render, staticRenderFns } from "./ChangeAppidModal.vue?vue&type=template&id=08019c46&scoped=true"
import script from "./ChangeAppidModal.vue?vue&type=script&lang=js"
export * from "./ChangeAppidModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeAppidModal.vue?vue&type=style&index=0&id=08019c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08019c46",
  null
  
)

export default component.exports